import React from "react";

export interface MailIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const Mail: React.FC<MailIconProps> = ({ width = 14, height = 14, color = "#9A9AB0" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6677 2.74982L7.42255 6.09024C7.24456 6.1936 7.04239 6.24805 6.83655 6.24805C6.63071 6.24805 6.42854 6.1936 6.25054 6.09024L1.00012 2.74982M2.16688 1H11.501C12.1453 1 12.6677 1.52228 12.6677 2.16655V9.16585C12.6677 9.81012 12.1453 10.3324 11.501 10.3324H2.16688C1.5225 10.3324 1.00012 9.81012 1.00012 9.16585V2.16655C1.00012 1.52228 1.5225 1 2.16688 1Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default Mail;
